<template>
    <b-badge :variant="field ? 'success' : 'danger'">
        {{ field ? "Aktif" : "Pasif" }}
    </b-badge>
</template>

<script>
import { BBadge } from "bootstrap-vue";

export default {
    name: "StatusBadge",
    components: {
        BBadge,
    },
    props: {
        field: {
            type: Boolean,
            default: false,
        },
        row: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>
